import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const initDirectionsLoadMore = () => {
    const section = document.querySelector('.directions');
    if (!section) return;

    const button = section.querySelector('[data-directions-load-more]');
    const grid = section.querySelector('.directions__list');
    if (!button || !grid) return;

    const allHiddenCards = Array.from(section.querySelectorAll('.directions__card--hidden, .directions__card--hidden-mobile'));
    if (!allHiddenCards.length) return;

    const getHiddenCards = () => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (isMobile) {
            return allHiddenCards;
        } else {
            return Array.from(section.querySelectorAll('.directions__card--hidden'));
        }
    };

    const animateItems = (items, show = true) => {
        items.forEach((item, index) => {
            if (item.dataset.animTimeout) {
                clearTimeout(parseInt(item.dataset.animTimeout));
            }

            if (show) {
                // Prepare item before showing
                item.style.display = 'flex';
                // Trigger reflow
                item.offsetHeight;

                const t = setTimeout(() => {
                    item.style.transition = 'opacity 0.6s ease, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)';
                    item.style.opacity = '1';
                    item.style.transform = 'translateY(0)';
                }, index * 100);
                item.dataset.animTimeout = t;
            } else {
                item.style.transition = 'opacity 0.6s ease, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)';
                item.style.opacity = '0';
                item.style.transform = 'translateY(20px)';

                const t = setTimeout(() => {
                    item.style.display = '';
                    item.style.opacity = '';
                    item.style.transform = '';
                    item.style.transition = '';
                }, 600);
                item.dataset.animTimeout = t;
            }
        });
    };

    // Preload hidden images
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            allHiddenCards.forEach(card => {
                const img = card.querySelector('img');
                if (img) img.setAttribute('loading', 'eager');
            });
            observer.disconnect();
        }
    }, { rootMargin: '400px' });
    observer.observe(section);

    clickOn('[data-directions-load-more]', (event, trigger) => {
        event.preventDefault();

        const btnText = trigger.querySelector('.btn__text');
        const textExpand = trigger.dataset.textExpand;
        const textCollapse = trigger.dataset.textCollapse;

        const targetCards = getHiddenCards();
        if (!targetCards.length) return;

        if (trigger.classList.contains('is-expanded')) {
            // Collapse
            animateItems(targetCards, false);
            trigger.classList.remove('is-expanded');
            if (btnText && textExpand) btnText.textContent = textExpand;

            setTimeout(() => {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
        } else {
            // Expand
            animateItems(targetCards, true);
            trigger.classList.add('is-expanded');
            if (btnText && textCollapse) btnText.textContent = textCollapse;
        }
    });

    // Clean up inline styles on breakpoint change to avoid layout bugs
    let isMobileState = window.matchMedia('(max-width: 768px)').matches;
    window.addEventListener('resize', () => {
        const newIsMobileState = window.matchMedia('(max-width: 768px)').matches;
        if (isMobileState !== newIsMobileState) {
            isMobileState = newIsMobileState;

            allHiddenCards.forEach(item => {
                if (item.dataset.animTimeout) {
                    clearTimeout(parseInt(item.dataset.animTimeout));
                }
                item.style.display = '';
                item.style.opacity = '';
                item.style.transform = '';
                item.style.transition = '';
            });

            if (button.classList.contains('is-expanded')) {
                button.classList.remove('is-expanded');
                const btnText = button.querySelector('.btn__text');
                const textExpand = button.dataset.textExpand;
                if (btnText && textExpand) btnText.textContent = textExpand;
            }
        }
    });
};

load(initDirectionsLoadMore);
